import axios from 'axios'
import React from 'react'
import adminStyles from './adminStyles.module.css'

import { useState } from 'react'

const AddLocation = () => {
   const[trname,setTrname]=useState("")
   const[location,setLocation]=useState("")
  
    const addSubServiceData=(e)=>{
        e.preventDefault();
          axios.post(`https://backendsurgylife-1.onrender.com/location`,{
              trname,
              location,
              })
          .then((res)=>{
              alert(" Location Added Successfully");
              setTrname("");
              setLocation("");
          })
          .catch((err)=>{
           alert("Error while adding  Location :")
          })
  }
  return (
 <main>
      

                      <section>
                       <div className='container'>
                           <div className='row'>
                               <div className='col-md-8 '>

                                <div className={adminStyles.bx_shadow}>
                                 <form onSubmit={addSubServiceData}>

                                  <div className='mb-3'>

                                <input 

                                 type='text'
                                 name='trname'
                                  placeholder='Treatment Name' 
                                  className='form-control'
                                  value={trname}
                                  onChange={
                                    (e)=>setTrname(e.target.value)
                                  }
                                  />
                                  </div>


                                  <div className='mb-3'>

                                   <textarea 
                                   className='form-control'
                                   placeholder='Location'
                                   value={location}
                                   onChange={
                                    (e)=>setLocation(e.target.value)
                                   }
                                   >

                                   </textarea>

                                  </div>

                                    <div className='mb-3'>
                                      
                                <input 
                                type='submit' 
                                value='Add Location'
                                className='btn btn-success'/>  

                                    </div>

                                 </form>

                          

                                </div>

                               </div>
                           </div>
                       </div>
                   </section>
    </main>  )
}

export default AddLocation
